import { Module } from './module.model';

export class SlackCommand {
    channel: string;

    constructor(tempModule: Module) {
        this.channel = tempModule.slackChannel || '';
    }
}
